<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutAlign="start">
    <p class="mt-0">{{ description | translate }}</p>
    <form [formGroup]="formGroup">
        <mat-form-field appearance="outline" class="w-100-p">
            <textarea
                matInput
                rows="5"
                name="comment"
                formControlName="comment"
                [placeholder]="'PAGE.MODULE_DETAILS.TAB.OVERVIEW.CANCEL_COURSE.DIALOG.PLACEHOLDER' | translate"
            ></textarea>
        </mat-form-field>
    </form>
</div>
<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button
        [color]="'warn'"
        [label]="'PAGE.MODULE_DETAILS.TAB.OVERVIEW.CANCEL_COURSE.DIALOG.BUTTON'"
        (onClick)="save()"
        [disabled]="!formGroup.value.comment"
    ></app-flat-button>
</div>
